import SelaTranscriptActiveMobile from './component.jsx'
export default SelaTranscriptActiveMobile
